<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wYYBV1/tc-custom/9781480441194.jpg?1733114256762" alt="This image is the cover for the book On the Contrary"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">On the Contrary
      </h1>
      <p class="bookDescription body article font2">
        <b>Mary McCarthy, one of our most brilliant and beloved authors, serves up wit, insight, and her unique worldview in this diverse collection of essays</b><br/>In provocatively titled pieces such as “The Contagion of Ideas,” “Tyranny of the Orgasm,” and “No News, <i>or</i>,What Killed the Dog,” Mary McCarthy expresses her frank, unflinching, often contrarian point of view.<br/>Nothing—and no one—is safe from her merciless writer’s eye—from politics to the ever-changing social scene to the strengths and weaknesses of her native country, where she believes “passivity and not aggressiveness is the dominant trait of the American character.” <i>On the Contrary </i>also features a cast of memorable characters. In “Naming Names,” Arthur Miller’s testimony before the House Un-American Activities Committee results in an indictment for contempt of Congress. McCarthy reviews <i>The Human Condition</i>, Hannah Arendt’s breakthrough book, and despairs of finding a “really American place” to take a visiting existentialist—a thinly disguised Simone de Beauvoir?  <br/>From Dickens to Gandhi to the Kinsey Reports, with pithy and wide-ranging articles on everything from fashion to fiction, the human condition, religion, and sex, <i>On the Contrary </i>raises controversial questions to which, even today, there are no easy answers.<br/>This ebook features an illustrated biography of Mary McCarthy including rare images from the author’s estate.    
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary McCarthy
      </h2>
      
      <p class="authorDescription body article">MARY MCCARTHY (1912&#8211;1989) was a short-story writer, bestselling novelist, essayist, and critic. She was the author of The Stones of Florence and Birds of America, among other books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?613438a3